import { Box, Button, Card, Stack } from '@mui/material';

import { Text, api, isDefined } from 'common';

import {
  FILTER_BLOCK_CASE_SENSITIVITY_NAMES,
  FILTER_BLOCK_NULL_OPERATORS,
  FILTER_BLOCK_OPERATOR_NAMES,
  FILTER_OPERATORS_NEED_CASE_SENSITIVITY,
} from './constants.js';
import { useReactFlowViewContext } from '../../../context/context.js';
import { BlockValueTemplateInnerField } from '../../ConfigFields/CodeMirror/FlowTemplate.js';
import { BlockRadioGroupField } from '../../ConfigFields/RadioGroupField.js';
import { BlockInnerSelectField } from '../../ConfigFields/SelectField.js';

const CaseSensitivity = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.CaseSensitivity;
const FilterOperator = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterOperator;
type FilterOperation = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterOperation;
type CaseSensitivity = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.CaseSensitivity;

interface FilterListBlockFilterOperationCardProps {
  fieldNamePrefix: string;
  onDelete?: () => void;
  filterOperation: FilterOperation;
}

export function FilterListBlockFilterOperationCard(props: FilterListBlockFilterOperationCardProps) {
  const { onDelete, fieldNamePrefix, filterOperation } = props;
  const { isEditable } = useReactFlowViewContext();

  return (
    <Card
      variant="outlined"
      sx={{
        paddingX: 1,
        paddingY: 1.5,
        backgroundColor: 'background.default',
        overflow: 'visible',
      }}
    >
      <Stack direction="row" gap={1} alignItems="flex-start">
        <Stack gap={2} flex={1}>
          <Stack>
            <Text bold>Filter on</Text>
            <BlockValueTemplateInnerField
              fieldId={`fieldToFilter-${filterOperation.id}`}
              fieldName={`${fieldNamePrefix}.fieldToFilter`}
              label="Field to filter"
              required
              isMultiline
            />
          </Stack>
          <BlockInnerSelectField
            fieldName={`${fieldNamePrefix}.operator`}
            options={Object.values(FilterOperator).map((entry) => ({
              label: FILTER_BLOCK_OPERATOR_NAMES[entry],
              value: entry,
            }))}
            aria-label="Operation"
            sx={{
              flex: 1,
              textAlign: 'center',
              '& :focus': { backgroundColor: 'transparent' },
            }}
          />
          {!FILTER_BLOCK_NULL_OPERATORS.includes(filterOperation.operator) && (
            <Stack>
              <Text bold>This value</Text>
              <BlockValueTemplateInnerField
                fieldId={`value-${filterOperation.id}`}
                fieldName={`${fieldNamePrefix}.value`}
                label="Filter Value"
                required
                isMultiline
              />
            </Stack>
          )}
          <Stack direction="column" gap={0}>
            {FILTER_OPERATORS_NEED_CASE_SENSITIVITY.includes(filterOperation.operator) && (
              <BlockRadioGroupField
                fieldName={`${fieldNamePrefix}.caseSensitive`}
                label=""
                aria-label="Case sensitivity"
                row
                defaultValue={CaseSensitivity.IgnoreCase}
                options={Object.values(CaseSensitivity).map((caseSensitivity) => ({
                  label: FILTER_BLOCK_CASE_SENSITIVITY_NAMES[caseSensitivity],
                  value: caseSensitivity,
                }))}
              />
            )}
            <Box display="flex" justifyContent="flex-end">
              <Button
                variant="text"
                color="error"
                aria-label="Delete filter"
                disabled={!isEditable || !isDefined(onDelete)}
                onClick={() => {
                  if (onDelete) {
                    onDelete();
                  }
                }}
              >
                Delete filter
              </Button>
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
}
